import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == typeof f && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(typeof r + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
import React__default, { useEffect, useCallback, useReducer, useMemo } from 'react';
import { f as format } from './index-ccef08fe.js';
import { getOutgoingMessageState, OutgoingMessageStates } from './utils/message/getOutgoingMessageState.js';
import { U as UserProfileProvider } from './UserProfileContext-f3f446d2.js';
import useSendbirdStateContext from './useSendbirdStateContext.js';
import { _ as _objectSpread2 } from './_rollupPluginBabelHelpers-05128ded.js';
import { ChannelStateTypes, ThreadListStateTypes, ParentMessageStateTypes } from './Thread/context/types.js';
import { ChannelType } from '@sendbird/chat';
import { P as PUBSUB_TOPICS } from './topics-eb548880.js';
import { GroupChannelHandler } from '@sendbird/chat/groupChannel';
import { u as uuidv4 } from './uuid-717930b4.js';
import { SendingStatus, MessageType, MessageMetaArray } from '@sendbird/chat/message';
import { b as VOICE_MESSAGE_FILE_NAME, c as VOICE_MESSAGE_MIME_TYPE, M as META_ARRAY_VOICE_DURATION_KEY, d as META_ARRAY_MESSAGE_TYPE_KEY, e as META_ARRAY_MESSAGE_TYPE_VALUE__VOICE } from './consts-fa6ab3c0.js';
var getNicknamesMapFromMembers = function getNicknamesMapFromMembers() {
  var members = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var nicknamesMap = new Map();
  for (var memberIndex = 0; memberIndex < members.length; memberIndex += 1) {
    var _members$memberIndex = members[memberIndex],
      userId = _members$memberIndex.userId,
      nickname = _members$memberIndex.nickname;
    nicknamesMap.set(userId, nickname);
  }
  return nicknamesMap;
};
var getParentMessageFrom = function getParentMessageFrom(message) {
  if (!message) {
    return null;
  }
  if (isParentMessage(message)) {
    return message;
  }
  if (isThreadMessage(message)) {
    return (message === null || message === void 0 ? void 0 : message.parentMessage) || null;
  }
  return null;
};
var isParentMessage = function isParentMessage(message) {
  return (message === null || message === void 0 ? void 0 : message.parentMessage) === null && typeof (message === null || message === void 0 ? void 0 : message.parentMessageId) === 'number' && !(message !== null && message !== void 0 && message.parentMessageId);
};
var isThreadMessage = function isThreadMessage(message) {
  return (message === null || message === void 0 ? void 0 : message.parentMessage) !== null && typeof (message === null || message === void 0 ? void 0 : message.parentMessageId) === 'number' && (message === null || message === void 0 ? void 0 : message.parentMessageId) > 0 && (message === null || message === void 0 ? void 0 : message.threadInfo) === null;
};
var isAboutSame = function isAboutSame(a, b, px) {
  return Math.abs(a - b) <= px;
};
var isEmpty = function isEmpty(val) {
  return val === null || val === undefined;
};

// Some Ids return string and number inconsistently
// only use to comapre IDs
function compareIds(a, b) {
  if (isEmpty(a) || isEmpty(b)) {
    return false;
  }
  var aString = a.toString();
  var bString = b.toString();
  return aString === bString;
}
var getMessageCreatedAt = function getMessageCreatedAt(message) {
  return format(message.createdAt, 'p');
};
var isReadMessage = function isReadMessage(channel, message) {
  return getOutgoingMessageState(channel, message) === OutgoingMessageStates.READ;
};
var isSameGroup = function isSameGroup(message, comparingMessage, currentChannel) {
  var _message$sender, _comparingMessage$sen, _message$sender2, _comparingMessage$sen2;
  if (!(message && comparingMessage && message.messageType && message.messageType !== 'admin' && comparingMessage.messageType && (comparingMessage === null || comparingMessage === void 0 ? void 0 : comparingMessage.messageType) !== 'admin' && message !== null && message !== void 0 && message.sender && comparingMessage !== null && comparingMessage !== void 0 && comparingMessage.sender && message !== null && message !== void 0 && message.createdAt && comparingMessage !== null && comparingMessage !== void 0 && comparingMessage.createdAt && message !== null && message !== void 0 && (_message$sender = message.sender) !== null && _message$sender !== void 0 && _message$sender.userId && comparingMessage !== null && comparingMessage !== void 0 && (_comparingMessage$sen = comparingMessage.sender) !== null && _comparingMessage$sen !== void 0 && _comparingMessage$sen.userId)) {
    return false;
  }
  return (message === null || message === void 0 ? void 0 : message.sendingStatus) === (comparingMessage === null || comparingMessage === void 0 ? void 0 : comparingMessage.sendingStatus) && (message === null || message === void 0 ? void 0 : (_message$sender2 = message.sender) === null || _message$sender2 === void 0 ? void 0 : _message$sender2.userId) === (comparingMessage === null || comparingMessage === void 0 ? void 0 : (_comparingMessage$sen2 = comparingMessage.sender) === null || _comparingMessage$sen2 === void 0 ? void 0 : _comparingMessage$sen2.userId) && getMessageCreatedAt(message) === getMessageCreatedAt(comparingMessage) && isReadMessage(currentChannel, message) === isReadMessage(currentChannel, comparingMessage);
};
var compareMessagesForGrouping = function compareMessagesForGrouping(prevMessage, currMessage, nextMessage, currentChannel, replyType) {
  if (replyType === 'THREAD' && currMessage !== null && currMessage !== void 0 && currMessage.threadInfo) {
    return [false, false];
  }
  var sendingStatus = (currMessage === null || currMessage === void 0 ? void 0 : currMessage.sendingStatus) || '';
  var isAcceptable = sendingStatus !== 'pending' && sendingStatus !== 'failed';
  return [isSameGroup(prevMessage, currMessage, currentChannel) && isAcceptable, isSameGroup(currMessage, nextMessage, currentChannel) && isAcceptable];
};
var scrollIntoLast = function scrollIntoLast() {
  var intialTry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var MAX_TRIES = 10;
  var currentTry = intialTry;
  if (currentTry > MAX_TRIES) {
    return;
  }
  try {
    var scrollDOM = document.querySelector('.sendbird-thread-ui--scroll');
    // eslint-disable-next-line no-multi-assign
    scrollDOM.scrollTop = scrollDOM.scrollHeight;
  } catch (error) {
    setTimeout(function () {
      scrollIntoLast(currentTry + 1);
    }, 500 * currentTry);
  }
};
var PREV_THREADS_FETCH_SIZE = 30;
var NEXT_THREADS_FETCH_SIZE = 30;
var ThreadContextActionTypes = /*#__PURE__*/function (ThreadContextActionTypes) {
  ThreadContextActionTypes["INIT_USER_ID"] = "INIT_USER_ID";
  ThreadContextActionTypes["GET_CHANNEL_START"] = "GET_CHANNEL_START";
  ThreadContextActionTypes["GET_CHANNEL_SUCCESS"] = "GET_CHANNEL_SUCCESS";
  ThreadContextActionTypes["GET_CHANNEL_FAILURE"] = "GET_CHANNEL_FAILURE";
  ThreadContextActionTypes["SET_EMOJI_CONTAINER"] = "SET_EMOJI_CONTAINER";
  ThreadContextActionTypes["GET_PARENT_MESSAGE_START"] = "GET_PARENT_MESSAGE_START";
  ThreadContextActionTypes["GET_PARENT_MESSAGE_SUCCESS"] = "GET_PARENT_MESSAGE_SUCCESS";
  ThreadContextActionTypes["GET_PARENT_MESSAGE_FAILURE"] = "GET_PARENT_MESSAGE_FAILURE";
  ThreadContextActionTypes["INITIALIZE_THREAD_LIST_START"] = "INITIALIZE_THREAD_LIST_START";
  ThreadContextActionTypes["INITIALIZE_THREAD_LIST_SUCCESS"] = "INITIALIZE_THREAD_LIST_SUCCESS";
  ThreadContextActionTypes["INITIALIZE_THREAD_LIST_FAILURE"] = "INITIALIZE_THREAD_LIST_FAILURE";
  ThreadContextActionTypes["GET_PREV_MESSAGES_START"] = "GET_PREV_MESSAGES_START";
  ThreadContextActionTypes["GET_PREV_MESSAGES_SUCESS"] = "GET_PREV_MESSAGES_SUCESS";
  ThreadContextActionTypes["GET_PREV_MESSAGES_FAILURE"] = "GET_PREV_MESSAGES_FAILURE";
  ThreadContextActionTypes["GET_NEXT_MESSAGES_START"] = "GET_NEXT_MESSAGES_START";
  ThreadContextActionTypes["GET_NEXT_MESSAGES_SUCESS"] = "GET_NEXT_MESSAGES_SUCESS";
  ThreadContextActionTypes["GET_NEXT_MESSAGES_FAILURE"] = "GET_NEXT_MESSAGES_FAILURE";
  ThreadContextActionTypes["SEND_MESSAGE_START"] = "SEND_MESSAGE_START";
  ThreadContextActionTypes["SEND_MESSAGE_SUCESS"] = "SEND_MESSAGE_SUCESS";
  ThreadContextActionTypes["SEND_MESSAGE_FAILURE"] = "SEND_MESSAGE_FAILURE";
  ThreadContextActionTypes["RESEND_MESSAGE_START"] = "RESEND_MESSAGE_START";
  ThreadContextActionTypes["ON_MESSAGE_DELETED_BY_REQ_ID"] = "ON_MESSAGE_DELETED_BY_REQ_ID";
  ThreadContextActionTypes["ON_MESSAGE_RECEIVED"] = "ON_MESSAGE_RECEIVED";
  ThreadContextActionTypes["ON_MESSAGE_UPDATED"] = "ON_MESSAGE_UPDATED";
  ThreadContextActionTypes["ON_MESSAGE_DELETED"] = "ON_MESSAGE_DELETED";
  ThreadContextActionTypes["ON_REACTION_UPDATED"] = "ON_REACTION_UPDATED";
  ThreadContextActionTypes["ON_USER_MUTED"] = "ON_USER_MUTED";
  ThreadContextActionTypes["ON_USER_UNMUTED"] = "ON_USER_UNMUTED";
  ThreadContextActionTypes["ON_USER_BANNED"] = "ON_USER_BANNED";
  ThreadContextActionTypes["ON_USER_UNBANNED"] = "ON_USER_UNBANNED";
  ThreadContextActionTypes["ON_USER_LEFT"] = "ON_USER_LEFT";
  ThreadContextActionTypes["ON_CHANNEL_FROZEN"] = "ON_CHANNEL_FROZEN";
  ThreadContextActionTypes["ON_CHANNEL_UNFROZEN"] = "ON_CHANNEL_UNFROZEN";
  ThreadContextActionTypes["ON_OPERATOR_UPDATED"] = "ON_OPERATOR_UPDATED";
  return ThreadContextActionTypes;
}({});
function reducer(state, action) {
  switch (action.type) {
    // initialize
    case ThreadContextActionTypes.INIT_USER_ID:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          currentUserId: action.payload
        });
      }
    case ThreadContextActionTypes.GET_CHANNEL_START:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          channelState: ChannelStateTypes.LOADING,
          currentChannel: null
        });
      }
    case ThreadContextActionTypes.GET_CHANNEL_SUCCESS:
      {
        var _groupChannel$members, _groupChannel$members2;
        var groupChannel = action.payload.groupChannel;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          channelState: ChannelStateTypes.INITIALIZED,
          currentChannel: groupChannel,
          // only support in normal group channel
          isMuted: (groupChannel === null || groupChannel === void 0 ? void 0 : (_groupChannel$members = groupChannel.members) === null || _groupChannel$members === void 0 ? void 0 : (_groupChannel$members2 = _groupChannel$members.find(function (member) {
            return (member === null || member === void 0 ? void 0 : member.userId) === state.currentUserId;
          })) === null || _groupChannel$members2 === void 0 ? void 0 : _groupChannel$members2.isMuted) || false,
          isChannelFrozen: (groupChannel === null || groupChannel === void 0 ? void 0 : groupChannel.isFrozen) || false
        });
      }
    case ThreadContextActionTypes.GET_CHANNEL_FAILURE:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          channelState: ChannelStateTypes.INVALID,
          currentChannel: null
        });
      }
    case ThreadContextActionTypes.SET_EMOJI_CONTAINER:
      {
        var emojiContainer = action.payload.emojiContainer;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          emojiContainer: emojiContainer
        });
      }
    case ThreadContextActionTypes.GET_PARENT_MESSAGE_START:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          parentMessageState: ParentMessageStateTypes.LOADING,
          parentMessage: null
        });
      }
    case ThreadContextActionTypes.GET_PARENT_MESSAGE_SUCCESS:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          parentMessageState: ParentMessageStateTypes.INITIALIZED,
          parentMessage: action.payload.parentMessage
        });
      }
    case ThreadContextActionTypes.GET_PARENT_MESSAGE_FAILURE:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          parentMessageState: ParentMessageStateTypes.INVALID,
          parentMessage: null
        });
      }
    // fetch threads
    case ThreadContextActionTypes.INITIALIZE_THREAD_LIST_START:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          threadListState: ThreadListStateTypes.LOADING,
          allThreadMessages: []
        });
      }
    case ThreadContextActionTypes.INITIALIZE_THREAD_LIST_SUCCESS:
      {
        var _action$payload2 = action.payload,
          parentMessage = _action$payload2.parentMessage,
          anchorMessage = _action$payload2.anchorMessage,
          threadedMessages = _action$payload2.threadedMessages;
        var anchorMessageCreatedAt = !(anchorMessage !== null && anchorMessage !== void 0 && anchorMessage.messageId) ? parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.createdAt : anchorMessage === null || anchorMessage === void 0 ? void 0 : anchorMessage.createdAt;
        var anchorIndex = threadedMessages.findIndex(function (message) {
          return (message === null || message === void 0 ? void 0 : message.createdAt) > anchorMessageCreatedAt;
        });
        var prevThreadMessages = anchorIndex > -1 ? threadedMessages.slice(0, anchorIndex) : threadedMessages;
        var anchorThreadMessage = anchorMessage !== null && anchorMessage !== void 0 && anchorMessage.messageId ? [anchorMessage] : [];
        var nextThreadMessages = anchorIndex > -1 ? threadedMessages.slice(anchorIndex) : [];
        return _objectSpread2(_objectSpread2({}, state), {}, {
          threadListState: ThreadListStateTypes.INITIALIZED,
          hasMorePrev: anchorIndex === -1 || anchorIndex === PREV_THREADS_FETCH_SIZE,
          hasMoreNext: threadedMessages.length - anchorIndex === NEXT_THREADS_FETCH_SIZE,
          allThreadMessages: [prevThreadMessages, anchorThreadMessage, nextThreadMessages].flat()
        });
      }
    case ThreadContextActionTypes.INITIALIZE_THREAD_LIST_FAILURE:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          threadListState: ThreadListStateTypes.INVALID,
          allThreadMessages: []
        });
      }
    case ThreadContextActionTypes.GET_NEXT_MESSAGES_START:
      {
        return _objectSpread2({}, state);
      }
    case ThreadContextActionTypes.GET_NEXT_MESSAGES_SUCESS:
      {
        var _threadedMessages = action.payload.threadedMessages;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          hasMoreNext: _threadedMessages.length === NEXT_THREADS_FETCH_SIZE,
          allThreadMessages: [].concat(_toConsumableArray(state.allThreadMessages), _toConsumableArray(_threadedMessages))
        });
      }
    case ThreadContextActionTypes.GET_NEXT_MESSAGES_FAILURE:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          hasMoreNext: false
        });
      }
    case ThreadContextActionTypes.GET_PREV_MESSAGES_START:
      {
        return _objectSpread2({}, state);
      }
    case ThreadContextActionTypes.GET_PREV_MESSAGES_SUCESS:
      {
        var _threadedMessages2 = action.payload.threadedMessages;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          hasMorePrev: _threadedMessages2.length === PREV_THREADS_FETCH_SIZE,
          allThreadMessages: [].concat(_toConsumableArray(_threadedMessages2), _toConsumableArray(state.allThreadMessages))
        });
      }
    case ThreadContextActionTypes.GET_PREV_MESSAGES_FAILURE:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          hasMorePrev: false
        });
      }
    // event handlers - message status change
    case ThreadContextActionTypes.ON_MESSAGE_RECEIVED:
      {
        var _state$currentChannel, _message$parentMessag, _state$parentMessage, _state$parentMessage2;
        var _action$payload3 = action.payload,
          channel = _action$payload3.channel,
          message = _action$payload3.message;
        if (((_state$currentChannel = state.currentChannel) === null || _state$currentChannel === void 0 ? void 0 : _state$currentChannel.url) !== (channel === null || channel === void 0 ? void 0 : channel.url) || state.hasMoreNext || (message === null || message === void 0 ? void 0 : (_message$parentMessag = message.parentMessage) === null || _message$parentMessag === void 0 ? void 0 : _message$parentMessag.messageId) !== (state === null || state === void 0 ? void 0 : (_state$parentMessage = state.parentMessage) === null || _state$parentMessage === void 0 ? void 0 : _state$parentMessage.messageId)) {
          return state;
        }
        var isAlreadyReceived = state.allThreadMessages.findIndex(function (m) {
          return m.messageId === message.messageId;
        }) > -1;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          parentMessage: ((_state$parentMessage2 = state.parentMessage) === null || _state$parentMessage2 === void 0 ? void 0 : _state$parentMessage2.messageId) === (message === null || message === void 0 ? void 0 : message.messageId) ? message : state.parentMessage,
          allThreadMessages: isAlreadyReceived ? state.allThreadMessages.map(function (m) {
            return m.messageId === message.messageId ? message : m;
          }) : [].concat(_toConsumableArray(state.allThreadMessages.filter(function (m) {
            return (m === null || m === void 0 ? void 0 : m.reqId) !== (message === null || message === void 0 ? void 0 : message.reqId);
          })), [message])
        });
      }
    case ThreadContextActionTypes.ON_MESSAGE_UPDATED:
      {
        var _state$currentChannel2, _state$parentMessage3, _state$allThreadMessa;
        var _action$payload4 = action.payload,
          _channel = _action$payload4.channel,
          _message = _action$payload4.message;
        if (((_state$currentChannel2 = state.currentChannel) === null || _state$currentChannel2 === void 0 ? void 0 : _state$currentChannel2.url) !== (_channel === null || _channel === void 0 ? void 0 : _channel.url)) {
          return state;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          parentMessage: ((_state$parentMessage3 = state.parentMessage) === null || _state$parentMessage3 === void 0 ? void 0 : _state$parentMessage3.messageId) === (_message === null || _message === void 0 ? void 0 : _message.messageId) ? _message : state.parentMessage,
          allThreadMessages: (_state$allThreadMessa = state.allThreadMessages) === null || _state$allThreadMessa === void 0 ? void 0 : _state$allThreadMessa.map(function (msg) {
            return (msg === null || msg === void 0 ? void 0 : msg.messageId) === (_message === null || _message === void 0 ? void 0 : _message.messageId) ? _message : msg;
          })
        });
      }
    case ThreadContextActionTypes.ON_MESSAGE_DELETED:
      {
        var _state$currentChannel3, _state$parentMessage4, _state$allThreadMessa2;
        var _action$payload5 = action.payload,
          _channel2 = _action$payload5.channel,
          messageId = _action$payload5.messageId;
        if (((_state$currentChannel3 = state.currentChannel) === null || _state$currentChannel3 === void 0 ? void 0 : _state$currentChannel3.url) !== (_channel2 === null || _channel2 === void 0 ? void 0 : _channel2.url)) {
          return state;
        }
        if ((state === null || state === void 0 ? void 0 : (_state$parentMessage4 = state.parentMessage) === null || _state$parentMessage4 === void 0 ? void 0 : _state$parentMessage4.messageId) === messageId) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            parentMessage: null,
            parentMessageState: ParentMessageStateTypes.NIL,
            allThreadMessages: []
          });
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allThreadMessages: (_state$allThreadMessa2 = state.allThreadMessages) === null || _state$allThreadMessa2 === void 0 ? void 0 : _state$allThreadMessa2.filter(function (msg) {
            return (msg === null || msg === void 0 ? void 0 : msg.messageId) !== messageId;
          })
        });
      }
    case ThreadContextActionTypes.ON_MESSAGE_DELETED_BY_REQ_ID:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allThreadMessages: state.allThreadMessages.filter(function (m) {
            return !compareIds(m.reqId, action.payload);
          })
        });
      }
    case ThreadContextActionTypes.ON_REACTION_UPDATED:
      {
        var _action$payload, _state$parentMessage5;
        var reactionEvent = (_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.reactionEvent;
        if ((state === null || state === void 0 ? void 0 : (_state$parentMessage5 = state.parentMessage) === null || _state$parentMessage5 === void 0 ? void 0 : _state$parentMessage5.messageId) === (reactionEvent === null || reactionEvent === void 0 ? void 0 : reactionEvent.messageId)) {
          var _state$parentMessage6, _state$parentMessage7;
          (_state$parentMessage6 = state.parentMessage) === null || _state$parentMessage6 === void 0 ? void 0 : (_state$parentMessage7 = _state$parentMessage6.applyReactionEvent) === null || _state$parentMessage7 === void 0 ? void 0 : _state$parentMessage7.call(_state$parentMessage6, reactionEvent);
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allThreadMessages: state.allThreadMessages.map(function (m) {
            if ((reactionEvent === null || reactionEvent === void 0 ? void 0 : reactionEvent.messageId) === (m === null || m === void 0 ? void 0 : m.messageId)) {
              var _m$applyReactionEvent;
              m === null || m === void 0 ? void 0 : (_m$applyReactionEvent = m.applyReactionEvent) === null || _m$applyReactionEvent === void 0 ? void 0 : _m$applyReactionEvent.call(m, reactionEvent);
              return m;
            }
            return m;
          })
        });
      }
    // event handlers - user status change
    case ThreadContextActionTypes.ON_USER_MUTED:
      {
        var _state$currentChannel4;
        var _action$payload6 = action.payload,
          _channel3 = _action$payload6.channel,
          user = _action$payload6.user;
        if (((_state$currentChannel4 = state.currentChannel) === null || _state$currentChannel4 === void 0 ? void 0 : _state$currentChannel4.url) !== (_channel3 === null || _channel3 === void 0 ? void 0 : _channel3.url) || state.currentUserId !== (user === null || user === void 0 ? void 0 : user.userId)) {
          return state;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isMuted: true
        });
      }
    case ThreadContextActionTypes.ON_USER_UNMUTED:
      {
        var _state$currentChannel5;
        var _action$payload7 = action.payload,
          _channel4 = _action$payload7.channel,
          _user = _action$payload7.user;
        if (((_state$currentChannel5 = state.currentChannel) === null || _state$currentChannel5 === void 0 ? void 0 : _state$currentChannel5.url) !== (_channel4 === null || _channel4 === void 0 ? void 0 : _channel4.url) || state.currentUserId !== (_user === null || _user === void 0 ? void 0 : _user.userId)) {
          return state;
        }
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isMuted: false
        });
      }
    case ThreadContextActionTypes.ON_USER_BANNED:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          channelState: ChannelStateTypes.NIL,
          threadListState: ThreadListStateTypes.NIL,
          parentMessageState: ParentMessageStateTypes.NIL,
          currentChannel: null,
          parentMessage: null,
          allThreadMessages: [],
          hasMorePrev: false,
          hasMoreNext: false
        });
      }
    case ThreadContextActionTypes.ON_USER_UNBANNED:
      {
        return _objectSpread2({}, state);
      }
    case ThreadContextActionTypes.ON_USER_LEFT:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          channelState: ChannelStateTypes.NIL,
          threadListState: ThreadListStateTypes.NIL,
          parentMessageState: ParentMessageStateTypes.NIL,
          currentChannel: null,
          parentMessage: null,
          allThreadMessages: [],
          hasMorePrev: false,
          hasMoreNext: false
        });
      }
    // event handler - channel status change
    case ThreadContextActionTypes.ON_CHANNEL_FROZEN:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isChannelFrozen: true
        });
      }
    case ThreadContextActionTypes.ON_CHANNEL_UNFROZEN:
      {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          isChannelFrozen: false
        });
      }
    case ThreadContextActionTypes.ON_OPERATOR_UPDATED:
      {
        var _state$currentChannel6;
        var _channel5 = action.payload.channel;
        if ((_channel5 === null || _channel5 === void 0 ? void 0 : _channel5.url) === ((_state$currentChannel6 = state.currentChannel) === null || _state$currentChannel6 === void 0 ? void 0 : _state$currentChannel6.url)) {
          return _objectSpread2(_objectSpread2({}, state), {}, {
            currentChannel: _channel5
          });
        }
        return state;
      }
    // message
    case ThreadContextActionTypes.SEND_MESSAGE_START:
      {
        var _message2 = action.payload.message;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allThreadMessages: [].concat(_toConsumableArray(state.allThreadMessages), [_message2])
        });
      }
    case ThreadContextActionTypes.SEND_MESSAGE_SUCESS:
      {
        var _message3 = action.payload.message;
        var filteredThreadMessages = state.allThreadMessages.filter(function (m) {
          return !compareIds(m === null || m === void 0 ? void 0 : m.reqId, _message3 === null || _message3 === void 0 ? void 0 : _message3.reqId);
        });
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allThreadMessages: [].concat(_toConsumableArray(filteredThreadMessages), [_message3])
        });
      }
    case ThreadContextActionTypes.SEND_MESSAGE_FAILURE:
      {
        var _message4 = action.payload.message;
        return _objectSpread2(_objectSpread2({}, state), {}, {
          allThreadMessages: state.allThreadMessages.map(function (m) {
            return compareIds(m === null || m === void 0 ? void 0 : m.reqId, _message4 === null || _message4 === void 0 ? void 0 : _message4.reqId) ? _message4 : m;
          })
        });
      }
    case ThreadContextActionTypes.RESEND_MESSAGE_START:
      {
        return _objectSpread2({}, state);
      }
    default:
      {
        return state;
      }
  }
}
var initialState = {
  currentChannel: null,
  allThreadMessages: [],
  parentMessage: null,
  channelState: ChannelStateTypes.NIL,
  parentMessageState: ParentMessageStateTypes.NIL,
  threadListState: ThreadListStateTypes.NIL,
  hasMorePrev: false,
  hasMoreNext: false,
  emojiContainer: {},
  isMuted: false,
  isChannelFrozen: false,
  currentUserId: ''
};
function useGetChannel(_ref, _ref2) {
  var channelUrl = _ref.channelUrl,
    sdkInit = _ref.sdkInit,
    message = _ref.message;
  var sdk = _ref2.sdk,
    logger = _ref2.logger,
    threadDispatcher = _ref2.threadDispatcher;
  useEffect(function () {
    // validation check
    if (sdkInit && channelUrl && sdk !== null && sdk !== void 0 && sdk.groupChannel) {
      var _sdk$groupChannel$get, _sdk$groupChannel;
      threadDispatcher({
        type: ThreadContextActionTypes.GET_CHANNEL_START,
        payload: null
      });
      (_sdk$groupChannel$get = (_sdk$groupChannel = sdk.groupChannel).getChannel) === null || _sdk$groupChannel$get === void 0 ? void 0 : _sdk$groupChannel$get.call(_sdk$groupChannel, channelUrl).then(function (groupChannel) {
        logger.info('Thread | useInitialize: Get channel succeeded', groupChannel);
        threadDispatcher({
          type: ThreadContextActionTypes.GET_CHANNEL_SUCCESS,
          payload: {
            groupChannel: groupChannel
          }
        });
      }).catch(function (error) {
        logger.info('Thread | useInitialize: Get channel failed', error);
        threadDispatcher({
          type: ThreadContextActionTypes.GET_CHANNEL_FAILURE,
          payload: error
        });
      });
    }
  }, [message, sdkInit]);
  /**
   * We don't use channelUrl here,
   * because Thread must operate independently of the channel.
   */
}
function useGetAllEmoji(_ref, _ref2) {
  var sdk = _ref.sdk;
  var logger = _ref2.logger,
    threadDispatcher = _ref2.threadDispatcher;
  useEffect(function () {
    if (sdk !== null && sdk !== void 0 && sdk.getAllEmoji) {
      // validation check
      sdk === null || sdk === void 0 ? void 0 : sdk.getAllEmoji().then(function (emojiContainer) {
        logger.info('Thread | useGetAllEmoji: Getting emojis succeeded.', emojiContainer);
        threadDispatcher({
          type: ThreadContextActionTypes.SET_EMOJI_CONTAINER,
          payload: {
            emojiContainer: emojiContainer
          }
        });
      }).catch(function (error) {
        logger.info('Thread | useGetAllEmoji: Getting emojis failed.', error);
      });
    }
  }, [sdk]);
}
function useGetThreadList(_ref, _ref2) {
  var sdkInit = _ref.sdkInit,
    parentMessage = _ref.parentMessage,
    anchorMessage = _ref.anchorMessage,
    isReactionEnabled = _ref.isReactionEnabled;
  var logger = _ref2.logger,
    threadDispatcher = _ref2.threadDispatcher;
  useEffect(function () {
    // validation check
    if (sdkInit && parentMessage !== null && parentMessage !== void 0 && parentMessage.getThreadedMessagesByTimestamp) {
      var _parentMessage$getThr;
      threadDispatcher({
        type: ThreadContextActionTypes.INITIALIZE_THREAD_LIST_START,
        payload: null
      });
      var timeStamp = (anchorMessage === null || anchorMessage === void 0 ? void 0 : anchorMessage.createdAt) || 0;
      var params = {
        prevResultSize: PREV_THREADS_FETCH_SIZE,
        nextResultSize: NEXT_THREADS_FETCH_SIZE,
        includeReactions: isReactionEnabled,
        includeMetaArray: true
      };
      logger.info('Thread | useGetThreadList: Initialize thread list start.', {
        timeStamp: timeStamp,
        params: params
      });
      (_parentMessage$getThr = parentMessage.getThreadedMessagesByTimestamp) === null || _parentMessage$getThr === void 0 ? void 0 : _parentMessage$getThr.call(parentMessage, timeStamp, params).then(function (_ref3) {
        var parentMessage = _ref3.parentMessage,
          threadedMessages = _ref3.threadedMessages;
        logger.info('Thread | useGetThreadList: Initialize thread list succeeded.', {
          parentMessage: parentMessage,
          threadedMessages: threadedMessages
        });
        threadDispatcher({
          type: ThreadContextActionTypes.INITIALIZE_THREAD_LIST_SUCCESS,
          payload: {
            parentMessage: parentMessage,
            anchorMessage: anchorMessage,
            threadedMessages: threadedMessages
          }
        });
      }).catch(function (error) {
        logger.info('Therad | useGetThreadList: Initialize thread list failed.', error);
        threadDispatcher({
          type: ThreadContextActionTypes.INITIALIZE_THREAD_LIST_FAILURE,
          payload: error
        });
      });
    }
  }, [sdkInit, parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId, anchorMessage]);
}
function useGetParentMessage(_ref, _ref2) {
  var channelUrl = _ref.channelUrl,
    sdkInit = _ref.sdkInit,
    parentMessage = _ref.parentMessage;
  var sdk = _ref2.sdk,
    logger = _ref2.logger,
    threadDispatcher = _ref2.threadDispatcher;
  useEffect(function () {
    var _sdk$message;
    // validation check
    if (sdkInit && sdk !== null && sdk !== void 0 && (_sdk$message = sdk.message) !== null && _sdk$message !== void 0 && _sdk$message.getMessage) {
      threadDispatcher({
        type: ThreadContextActionTypes.GET_PARENT_MESSAGE_START,
        payload: null
      });
      var params = {
        channelUrl: channelUrl,
        channelType: ChannelType.GROUP,
        messageId: parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId,
        includeMetaArray: true,
        includeReactions: true,
        includeThreadInfo: true,
        includeParentMessageInfo: true
      };
      logger.info('Thread | useGetParentMessage: Get parent message start.', params);
      var fetchParentMessage = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var _sdk$message$getMessa, _sdk$message2, data;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (_sdk$message$getMessa = (_sdk$message2 = sdk.message).getMessage) === null || _sdk$message$getMessa === void 0 ? void 0 : _sdk$message$getMessa.call(_sdk$message2, params);
              case 2:
                data = _context.sent;
                return _context.abrupt("return", data);
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function fetchParentMessage() {
          return _ref4.apply(this, arguments);
        };
      }();
      fetchParentMessage().then(function (parentMsg) {
        logger.info('Thread | useGetParentMessage: Get parent message succeeded.', parentMessage);
        parentMsg.ogMetaData = (parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.ogMetaData) || null; // ogMetaData is not included for now
        threadDispatcher({
          type: ThreadContextActionTypes.GET_PARENT_MESSAGE_SUCCESS,
          payload: {
            parentMessage: parentMsg
          }
        });
      }).catch(function (error) {
        logger.info('Thread | useGetParentMessage: Get parent message failed.', error);
        threadDispatcher({
          type: ThreadContextActionTypes.GET_PARENT_MESSAGE_FAILURE,
          payload: error
        });
      });
    }
  }, [sdkInit, parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId]);
  /**
   * We don't use channelUrl here,
   * because Thread must operate independently of the channel.
   */
}
function useHandlePubsubEvents(_ref, _ref2) {
  var sdkInit = _ref.sdkInit,
    currentChannel = _ref.currentChannel,
    parentMessage = _ref.parentMessage;
  var pubSub = _ref2.pubSub,
    threadDispatcher = _ref2.threadDispatcher;
  useEffect(function () {
    var pubSubHandler = function pubSubHandler() {
      var subscriber = new Map();
      if (!pubSub || !pubSub.subscribe) {
        return subscriber;
      }
      subscriber.set(PUBSUB_TOPICS.SEND_USER_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.SEND_USER_MESSAGE, function (props) {
        var channel = props.channel,
          message = props.message;
        if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url) && (message === null || message === void 0 ? void 0 : message.parentMessageId) === (parentMessage === null || parentMessage === void 0 ? void 0 : parentMessage.messageId)) {
          threadDispatcher({
            type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
            payload: {
              message: message
            }
          });
        }
        scrollIntoLast === null || scrollIntoLast === void 0 ? void 0 : scrollIntoLast();
      }));
      subscriber.set(PUBSUB_TOPICS.SEND_FILE_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.SEND_FILE_MESSAGE, function (props) {
        var channel = props.channel,
          message = props.message;
        if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url)) {
          threadDispatcher({
            type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
            payload: {
              message: message
            }
          });
        }
        scrollIntoLast === null || scrollIntoLast === void 0 ? void 0 : scrollIntoLast();
      }));
      subscriber.set(PUBSUB_TOPICS.UPDATE_USER_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.UPDATE_USER_MESSAGE, function (msg) {
        var channel = msg.channel,
          message = msg.message;
        if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url)) {
          threadDispatcher({
            type: ThreadContextActionTypes.ON_MESSAGE_UPDATED,
            payload: {
              channel: channel,
              message: message
            }
          });
        }
      }));
      subscriber.set(PUBSUB_TOPICS.DELETE_MESSAGE, pubSub.subscribe(PUBSUB_TOPICS.DELETE_MESSAGE, function (msg) {
        var channel = msg.channel,
          messageId = msg.messageId;
        if ((currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.url) === (channel === null || channel === void 0 ? void 0 : channel.url)) {
          threadDispatcher({
            type: ThreadContextActionTypes.ON_MESSAGE_DELETED,
            payload: {
              messageId: messageId
            }
          });
        }
      }));
    };
    var subscriber = pubSubHandler();
    return function () {
      subscriber === null || subscriber === void 0 ? void 0 : subscriber.forEach(function (s) {
        try {
          s === null || s === void 0 ? void 0 : s.remove();
        } catch (_unused) {
          //
        }
      });
    };
  }, [sdkInit, currentChannel]);
}
function useHandleChannelEvents(_ref, _ref2) {
  var sdk = _ref.sdk,
    currentChannel = _ref.currentChannel;
  var logger = _ref2.logger,
    threadDispatcher = _ref2.threadDispatcher;
  useEffect(function () {
    var _sdk$groupChannel;
    var handlerId = uuidv4();
    // validation check
    if (sdk !== null && sdk !== void 0 && (_sdk$groupChannel = sdk.groupChannel) !== null && _sdk$groupChannel !== void 0 && _sdk$groupChannel.addGroupChannelHandler && currentChannel) {
      var _sdk$groupChannel$add, _sdk$groupChannel2;
      var channelHandlerParams = {
        // message status change
        onMessageReceived: function onMessageReceived(channel, message) {
          logger.info('Thread | useHandleChannelEvents: onMessageReceived', {
            channel: channel,
            message: message
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_MESSAGE_RECEIVED,
            payload: {
              channel: channel,
              message: message
            }
          });
        },
        onMessageUpdated: function onMessageUpdated(channel, message) {
          logger.info('Thread | useHandleChannelEvents: onMessageUpdated', {
            channel: channel,
            message: message
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_MESSAGE_UPDATED,
            payload: {
              channel: channel,
              message: message
            }
          });
        },
        onMessageDeleted: function onMessageDeleted(channel, messageId) {
          logger.info('Thread | useHandleChannelEvents: onMessageDeleted', {
            channel: channel,
            messageId: messageId
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_MESSAGE_DELETED,
            payload: {
              channel: channel,
              messageId: messageId
            }
          });
        },
        onReactionUpdated: function onReactionUpdated(channel, reactionEvent) {
          logger.info('Thread | useHandleChannelEvents: onReactionUpdated', {
            channel: channel,
            reactionEvent: reactionEvent
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_REACTION_UPDATED,
            payload: {
              channel: channel,
              reactionEvent: reactionEvent
            }
          });
        },
        // user status change
        onUserMuted: function onUserMuted(channel, user) {
          logger.info('Thread | useHandleChannelEvents: onUserMuted', {
            channel: channel,
            user: user
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_USER_MUTED,
            payload: {
              channel: channel,
              user: user
            }
          });
        },
        onUserUnmuted: function onUserUnmuted(channel, user) {
          logger.info('Thread | useHandleChannelEvents: onUserUnmuted', {
            channel: channel,
            user: user
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_USER_UNMUTED,
            payload: {
              channel: channel,
              user: user
            }
          });
        },
        onUserBanned: function onUserBanned(channel, user) {
          logger.info('Thread | useHandleChannelEvents: onUserBanned', {
            channel: channel,
            user: user
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_USER_BANNED,
            payload: {
              channel: channel,
              user: user
            }
          });
        },
        onUserUnbanned: function onUserUnbanned(channel, user) {
          logger.info('Thread | useHandleChannelEvents: onUserUnbanned', {
            channel: channel,
            user: user
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_USER_UNBANNED,
            payload: {
              channel: channel,
              user: user
            }
          });
        },
        onUserLeft: function onUserLeft(channel, user) {
          logger.info('Thread | useHandleChannelEvents: onUserLeft', {
            channel: channel,
            user: user
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_USER_LEFT,
            payload: {
              channel: channel,
              user: user
            }
          });
        },
        // channel status change
        onChannelFrozen: function onChannelFrozen(channel) {
          logger.info('Thread | useHandleChannelEvents: onChannelFrozen', {
            channel: channel
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_CHANNEL_FROZEN,
            payload: {
              channel: channel
            }
          });
        },
        onChannelUnfrozen: function onChannelUnfrozen(channel) {
          logger.info('Thread | useHandleChannelEvents: onChannelUnfrozen', {
            channel: channel
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_CHANNEL_UNFROZEN,
            payload: {
              channel: channel
            }
          });
        },
        onOperatorUpdated: function onOperatorUpdated(channel, users) {
          logger.info('Thread | useHandleChannelEvents: onOperatorUpdated', {
            channel: channel,
            users: users
          });
          threadDispatcher({
            type: ThreadContextActionTypes.ON_OPERATOR_UPDATED,
            payload: {
              channel: channel,
              users: users
            }
          });
        }
      };
      var channelHandler = new GroupChannelHandler(channelHandlerParams);
      (_sdk$groupChannel$add = (_sdk$groupChannel2 = sdk.groupChannel).addGroupChannelHandler) === null || _sdk$groupChannel$add === void 0 ? void 0 : _sdk$groupChannel$add.call(_sdk$groupChannel2, handlerId, channelHandler);
      logger.info('Thread | useHandleChannelEvents: Added channelHandler in Thread', {
        handlerId: handlerId,
        channelHandler: channelHandler
      });
    }
    return function () {
      var _sdk$groupChannel3;
      // validation check
      if (handlerId && sdk !== null && sdk !== void 0 && (_sdk$groupChannel3 = sdk.groupChannel) !== null && _sdk$groupChannel3 !== void 0 && _sdk$groupChannel3.removeGroupChannelHandler) {
        var _sdk$groupChannel$rem, _sdk$groupChannel4;
        (_sdk$groupChannel$rem = (_sdk$groupChannel4 = sdk.groupChannel).removeGroupChannelHandler) === null || _sdk$groupChannel$rem === void 0 ? void 0 : _sdk$groupChannel$rem.call(_sdk$groupChannel4, handlerId);
        logger.info('Thread | useHandleChannelEvents: Removed channelHandler in Thread.', handlerId);
      }
    };
  }, [sdk === null || sdk === void 0 ? void 0 : sdk.groupChannel, currentChannel]);
}
function useSendFileMessageCallback(_ref, _ref2) {
  var currentChannel = _ref.currentChannel;
  var logger = _ref2.logger,
    pubSub = _ref2.pubSub,
    threadDispatcher = _ref2.threadDispatcher;
  var sendMessage = useCallback(function (file, quoteMessage) {
    var createParamsDefault = function createParamsDefault() {
      var params = {};
      params.file = file;
      if (quoteMessage) {
        params.isReplyToChannel = true;
        params.parentMessageId = quoteMessage.messageId;
      }
      return params;
    };
    var params = createParamsDefault();
    logger.info('Thread | useSendFileMessageCallback: Sending file message start.', params);
    currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendFileMessage(params).onPending(function (pendingMessage) {
      threadDispatcher({
        type: ThreadContextActionTypes.SEND_MESSAGE_START,
        payload: {
          /* pubSub is used instead of messagesDispatcher
          to avoid redundantly calling `messageActionTypes.SEND_MESSAGEGE_START` */
          message: _objectSpread2(_objectSpread2({}, pendingMessage), {}, {
            url: URL.createObjectURL(file),
            // pending thumbnail message seems to be failed
            requestState: 'pending'
          })
        }
      });
      setTimeout(function () {
        return scrollIntoLast();
      }, 1000);
    }).onFailed(function (error, message) {
      message.localUrl = URL.createObjectURL(file);
      message.file = file;
      logger.info('Thread | useSendFileMessageCallback: Sending file message failed.', {
        message: message,
        error: error
      });
      threadDispatcher({
        type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
        payload: {
          message: message,
          error: error
        }
      });
    }).onSucceeded(function (message) {
      logger.info('Thread | useSendFileMessageCallback: Sending file message succeeded.', message);
      pubSub.publish(PUBSUB_TOPICS.SEND_FILE_MESSAGE, {
        channel: currentChannel,
        message: message
      });
    });
  }, [currentChannel]);
  return sendMessage;
}
function useUpdateMessageCallback(_ref, _ref2) {
  var currentChannel = _ref.currentChannel,
    isMentionEnabled = _ref.isMentionEnabled;
  var logger = _ref2.logger,
    pubSub = _ref2.pubSub,
    threadDispatcher = _ref2.threadDispatcher;
  return useCallback(function (props) {
    var _currentChannel$updat;
    var messageId = props.messageId,
      message = props.message,
      mentionedUsers = props.mentionedUsers,
      mentionTemplate = props.mentionTemplate;
    var createParamsDefault = function createParamsDefault() {
      var params = {};
      params.message = message;
      if (isMentionEnabled && (mentionedUsers === null || mentionedUsers === void 0 ? void 0 : mentionedUsers.length) > 0) {
        params.mentionedUsers = mentionedUsers;
      }
      if (isMentionEnabled && mentionTemplate) {
        params.mentionedMessageTemplate = mentionTemplate;
      } else {
        params.mentionedMessageTemplate = message;
      }
      return params;
    };
    var params = createParamsDefault();
    logger.info('Thread | useUpdateMessageCallback: Message update start.', params);
    currentChannel === null || currentChannel === void 0 ? void 0 : (_currentChannel$updat = currentChannel.updateUserMessage) === null || _currentChannel$updat === void 0 ? void 0 : _currentChannel$updat.call(currentChannel, messageId, params).then(function (message) {
      logger.info('Thread | useUpdateMessageCallback: Message update succeeded.', message);
      threadDispatcher({
        type: ThreadContextActionTypes.ON_MESSAGE_UPDATED,
        payload: {
          channel: currentChannel,
          message: message
        }
      });
      pubSub.publish(PUBSUB_TOPICS.UPDATE_USER_MESSAGE, {
        fromSelector: true,
        channel: currentChannel,
        message: message
      });
    });
  }, [currentChannel, isMentionEnabled]);
}
function useDeleteMessageCallback(_ref, _ref2) {
  var currentChannel = _ref.currentChannel,
    threadDispatcher = _ref.threadDispatcher;
  var logger = _ref2.logger;
  return useCallback(function (message) {
    logger.info('Thread | useDeleteMessageCallback: Deleting message.', message);
    var sendingStatus = message.sendingStatus;
    return new Promise(function (resolve, reject) {
      var _currentChannel$delet;
      logger.info('Thread | useDeleteMessageCallback: Deleting message requestState:', sendingStatus);
      // Message is only on local
      if (sendingStatus === 'failed' || sendingStatus === 'pending') {
        logger.info('Thread | useDeleteMessageCallback: Deleted message from local:', message);
        threadDispatcher({
          type: ThreadContextActionTypes.ON_MESSAGE_DELETED_BY_REQ_ID,
          payload: message.reqId
        });
        resolve(message);
      }
      logger.info('Thread | useDeleteMessageCallback: Deleting message from remote:', sendingStatus);
      currentChannel === null || currentChannel === void 0 ? void 0 : (_currentChannel$delet = currentChannel.deleteMessage) === null || _currentChannel$delet === void 0 ? void 0 : _currentChannel$delet.call(currentChannel, message).then(function () {
        logger.info('Thread | useDeleteMessageCallback: Deleting message success!', message);
        threadDispatcher({
          type: ThreadContextActionTypes.ON_MESSAGE_DELETED,
          payload: {
            message: message,
            channel: currentChannel
          }
        });
        resolve(message);
      }).catch(function (err) {
        logger.warning('Thread | useDeleteMessageCallback: Deleting message failed!', err);
        reject(err);
      });
    });
  }, [currentChannel]);
}
function useGetPrevThreadsCallback(_ref, _ref2) {
  var hasMorePrev = _ref.hasMorePrev,
    parentMessage = _ref.parentMessage,
    threadListState = _ref.threadListState,
    oldestMessageTimeStamp = _ref.oldestMessageTimeStamp,
    isReactionEnabled = _ref.isReactionEnabled;
  var logger = _ref2.logger,
    threadDispatcher = _ref2.threadDispatcher;
  return useCallback(function (callback) {
    // validation check
    if (threadListState === ThreadListStateTypes.INITIALIZED && parentMessage !== null && parentMessage !== void 0 && parentMessage.getThreadedMessagesByTimestamp && oldestMessageTimeStamp !== 0) {
      var _parentMessage$getThr;
      threadDispatcher({
        type: ThreadContextActionTypes.GET_PREV_MESSAGES_START,
        payload: null
      });
      (_parentMessage$getThr = parentMessage.getThreadedMessagesByTimestamp) === null || _parentMessage$getThr === void 0 ? void 0 : _parentMessage$getThr.call(parentMessage, oldestMessageTimeStamp, {
        prevResultSize: PREV_THREADS_FETCH_SIZE,
        nextResultSize: 0,
        includeReactions: isReactionEnabled,
        includeMetaArray: true
      }).then(function (_ref3) {
        var parentMessage = _ref3.parentMessage,
          threadedMessages = _ref3.threadedMessages;
        logger.info('Thread | useGetPrevThreadsCallback: Fetch prev threads succeeded.', {
          parentMessage: parentMessage,
          threadedMessages: threadedMessages
        });
        threadDispatcher({
          type: ThreadContextActionTypes.GET_PREV_MESSAGES_SUCESS,
          payload: {
            parentMessage: parentMessage,
            threadedMessages: threadedMessages
          }
        });
        callback(threadedMessages);
      }).catch(function (error) {
        logger.info('Thread | useGetPrevThreadsCallback: Fetch prev threads failed.', error);
        threadDispatcher({
          type: ThreadContextActionTypes.GET_PREV_MESSAGES_FAILURE,
          payload: error
        });
      });
    }
  }, [hasMorePrev, parentMessage, threadListState, oldestMessageTimeStamp]);
}
function useGetNextThreadsCallback(_ref, _ref2) {
  var hasMoreNext = _ref.hasMoreNext,
    parentMessage = _ref.parentMessage,
    threadListState = _ref.threadListState,
    latestMessageTimeStamp = _ref.latestMessageTimeStamp,
    isReactionEnabled = _ref.isReactionEnabled;
  var logger = _ref2.logger,
    threadDispatcher = _ref2.threadDispatcher;
  return useCallback(function (callback) {
    // validation check
    if (threadListState === ThreadListStateTypes.INITIALIZED && parentMessage !== null && parentMessage !== void 0 && parentMessage.getThreadedMessagesByTimestamp && latestMessageTimeStamp !== 0) {
      var _parentMessage$getThr;
      threadDispatcher({
        type: ThreadContextActionTypes.GET_NEXT_MESSAGES_START,
        payload: null
      });
      (_parentMessage$getThr = parentMessage.getThreadedMessagesByTimestamp) === null || _parentMessage$getThr === void 0 ? void 0 : _parentMessage$getThr.call(parentMessage, latestMessageTimeStamp, {
        prevResultSize: 0,
        nextResultSize: NEXT_THREADS_FETCH_SIZE,
        includeReactions: isReactionEnabled,
        includeMetaArray: true
      }).then(function (_ref3) {
        var parentMessage = _ref3.parentMessage,
          threadedMessages = _ref3.threadedMessages;
        logger.info('Thread | useGetNextThreadsCallback: Fetch next threads succeeded.', {
          parentMessage: parentMessage,
          threadedMessages: threadedMessages
        });
        threadDispatcher({
          type: ThreadContextActionTypes.GET_NEXT_MESSAGES_SUCESS,
          payload: {
            parentMessage: parentMessage,
            threadedMessages: threadedMessages
          }
        });
        callback(threadedMessages);
      }).catch(function (error) {
        logger.info('Thread | useGetNextThreadsCallback: Fetch next threads failed.', error);
        threadDispatcher({
          type: ThreadContextActionTypes.GET_NEXT_MESSAGES_FAILURE,
          payload: error
        });
      });
    }
  }, [hasMoreNext, parentMessage, threadListState, latestMessageTimeStamp]);
}
function useToggleReactionCallback(_ref, _ref2) {
  var currentChannel = _ref.currentChannel;
  var logger = _ref2.logger;
  return useCallback(function (message, key, isReacted) {
    var _currentChannel$addRe;
    if (isReacted) {
      var _currentChannel$delet;
      currentChannel === null || currentChannel === void 0 ? void 0 : (_currentChannel$delet = currentChannel.deleteReaction) === null || _currentChannel$delet === void 0 ? void 0 : _currentChannel$delet.call(currentChannel, message, key).then(function (res) {
        logger.info('Thread | useToggleReactionsCallback: Delete reaction succeeded.', res);
      }).catch(function (err) {
        logger.warning('Thread | useToggleReactionsCallback: Delete reaction failed.', err);
      });
      return;
    }
    currentChannel === null || currentChannel === void 0 ? void 0 : (_currentChannel$addRe = currentChannel.addReaction) === null || _currentChannel$addRe === void 0 ? void 0 : _currentChannel$addRe.call(currentChannel, message, key).then(function (res) {
      logger.info('Thread | useToggleReactionsCallback: Add reaction succeeded.', res);
    }).catch(function (err) {
      logger.warning('Thread | useToggleReactionsCallback: Add reaction failed.', err);
    });
  }, [currentChannel]);
}
function useSendUserMessageCallback(_ref, _ref2) {
  var isMentionEnabled = _ref.isMentionEnabled,
    currentChannel = _ref.currentChannel;
  var logger = _ref2.logger,
    pubSub = _ref2.pubSub,
    threadDispatcher = _ref2.threadDispatcher;
  var sendMessage = useCallback(function (props) {
    var message = props.message,
      _props$quoteMessage = props.quoteMessage,
      quoteMessage = _props$quoteMessage === void 0 ? null : _props$quoteMessage,
      mentionTemplate = props.mentionTemplate,
      mentionedUsers = props.mentionedUsers;
    var createDefaultParams = function createDefaultParams() {
      var params = {};
      params.message = message;
      if (isMentionEnabled && (mentionedUsers === null || mentionedUsers === void 0 ? void 0 : mentionedUsers.length) > 0) {
        params.mentionedUsers = mentionedUsers;
      }
      if (isMentionEnabled && mentionTemplate && (mentionedUsers === null || mentionedUsers === void 0 ? void 0 : mentionedUsers.length) > 0) {
        params.mentionedMessageTemplate = mentionTemplate;
      }
      if (quoteMessage) {
        params.isReplyToChannel = true;
        params.parentMessageId = quoteMessage.messageId;
      }
      return params;
    };
    var params = createDefaultParams();
    logger.info('Thread | useSendUserMessageCallback: Sending user message start.', params);
    if (currentChannel !== null && currentChannel !== void 0 && currentChannel.sendUserMessage) {
      currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendUserMessage(params).onPending(function (pendingMessage) {
        threadDispatcher({
          type: ThreadContextActionTypes.SEND_MESSAGE_START,
          payload: {
            message: pendingMessage
          }
        });
      }).onFailed(function (error, message) {
        logger.info('Thread | useSendUserMessageCallback: Sending user message failed.', {
          message: message,
          error: error
        });
        threadDispatcher({
          type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
          payload: {
            error: error,
            message: message
          }
        });
      }).onSucceeded(function (message) {
        logger.info('Thread | useSendUserMessageCallback: Sending user message succeeded.', message);
        threadDispatcher({
          type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
          payload: {
            message: message
          }
        });
        // because Thread doesn't subscribe SEND_USER_MESSAGE
        pubSub.publish(PUBSUB_TOPICS.SEND_USER_MESSAGE, {
          channel: currentChannel,
          message: message
        });
      });
    }
  }, [isMentionEnabled, currentChannel]);
  return sendMessage;
}
function useResendMessageCallback(_ref, _ref2) {
  var currentChannel = _ref.currentChannel;
  var logger = _ref2.logger,
    pubSub = _ref2.pubSub,
    threadDispatcher = _ref2.threadDispatcher;
  return useCallback(function (failedMessage) {
    if (failedMessage !== null && failedMessage !== void 0 && failedMessage.isResendable) {
      var _failedMessage$isUser, _failedMessage$isFile;
      failedMessage.sendingStatus = SendingStatus.PENDING;
      logger.info('Thread | useResendMessageCallback: Resending failedMessage start.', failedMessage);
      threadDispatcher({
        type: ThreadContextActionTypes.RESEND_MESSAGE_START,
        payload: failedMessage
      });
      if (failedMessage !== null && failedMessage !== void 0 && (_failedMessage$isUser = failedMessage.isUserMessage) !== null && _failedMessage$isUser !== void 0 && _failedMessage$isUser.call(failedMessage) || (failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.messageType) === MessageType.USER) {
        currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.resendUserMessage(failedMessage).then(function (message) {
          logger.info('Thread | useResendMessageCallback: Resending failedMessage succeeded.', message);
          threadDispatcher({
            type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
            payload: {
              message: message
            }
          });
          pubSub.publish(PUBSUB_TOPICS.SEND_USER_MESSAGE, {
            channel: currentChannel,
            message: message
          });
        }).catch(function (error) {
          logger.warning('Thread | useResendMessageCallback: Resending failedMessage failed.', error);
          failedMessage.sendingStatus = SendingStatus.FAILED;
          threadDispatcher({
            type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
            payload: {
              message: failedMessage
            }
          });
        });
      } else if (failedMessage !== null && failedMessage !== void 0 && (_failedMessage$isFile = failedMessage.isFileMessage) !== null && _failedMessage$isFile !== void 0 && _failedMessage$isFile.call(failedMessage) || (failedMessage === null || failedMessage === void 0 ? void 0 : failedMessage.messageType) === MessageType.FILE) {
        var _currentChannel$resen;
        currentChannel === null || currentChannel === void 0 ? void 0 : (_currentChannel$resen = currentChannel.resendFileMessage) === null || _currentChannel$resen === void 0 ? void 0 : _currentChannel$resen.call(currentChannel, failedMessage).then(function (message) {
          logger.info('Thread | useResendMessageCallback: Resending failedMessage succeeded.', message);
          threadDispatcher({
            type: ThreadContextActionTypes.SEND_MESSAGE_SUCESS,
            payload: {
              message: message
            }
          });
        }).catch(function (error) {
          logger.warning('Thread | useResendMessageCallback: Resending failedMessage failed.', error);
          failedMessage.sendingStatus = SendingStatus.FAILED;
          threadDispatcher({
            type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
            payload: {
              message: failedMessage
            }
          });
          pubSub.publish(PUBSUB_TOPICS.SEND_FILE_MESSAGE, {
            channel: currentChannel,
            message: failedMessage
          });
        });
      } else {
        logger.warning('Thread | useResendMessageCallback: Message is not resendable.', failedMessage);
        failedMessage.sendingStatus = SendingStatus.FAILED;
        threadDispatcher({
          type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
          payload: {
            message: failedMessage
          }
        });
      }
    }
  }, [currentChannel]);
}
var useSendVoiceMessageCallback = function useSendVoiceMessageCallback(_ref, _ref2) {
  var currentChannel = _ref.currentChannel,
    onBeforeSendVoiceMessage = _ref.onBeforeSendVoiceMessage;
  var logger = _ref2.logger,
    pubSub = _ref2.pubSub,
    threadDispatcher = _ref2.threadDispatcher;
  var sendMessage = useCallback(function (file, duration, quoteMessage) {
    var messageParams = onBeforeSendVoiceMessage && typeof onBeforeSendVoiceMessage === 'function' ? onBeforeSendVoiceMessage(file, quoteMessage) : {
      file: file,
      fileName: VOICE_MESSAGE_FILE_NAME,
      mimeType: VOICE_MESSAGE_MIME_TYPE,
      metaArrays: [new MessageMetaArray({
        key: META_ARRAY_VOICE_DURATION_KEY,
        value: ["".concat(duration)]
      }), new MessageMetaArray({
        key: META_ARRAY_MESSAGE_TYPE_KEY,
        value: [META_ARRAY_MESSAGE_TYPE_VALUE__VOICE]
      })]
    };
    if (quoteMessage) {
      messageParams.isReplyToChannel = true;
      messageParams.parentMessageId = quoteMessage.messageId;
    }
    logger.info('Thread | useSendVoiceMessageCallback:  Start sending voice message', messageParams);
    currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.sendFileMessage(messageParams).onPending(function (pendingMessage) {
      threadDispatcher({
        type: ThreadContextActionTypes.SEND_MESSAGE_START,
        payload: {
          /* pubSub is used instead of messagesDispatcher
          to avoid redundantly calling `messageActionTypes.SEND_MESSAGEGE_START` */
          message: _objectSpread2(_objectSpread2({}, pendingMessage), {}, {
            url: URL.createObjectURL(file),
            // pending thumbnail message seems to be failed
            requestState: 'pending'
          })
        }
      });
      setTimeout(function () {
        return scrollIntoLast();
      }, 1000);
    }).onFailed(function (error, message) {
      message.localUrl = URL.createObjectURL(file);
      message.file = file;
      logger.info('Thread | useSendVoiceMessageCallback: Sending voice message failed.', {
        message: message,
        error: error
      });
      threadDispatcher({
        type: ThreadContextActionTypes.SEND_MESSAGE_FAILURE,
        payload: {
          message: message,
          error: error
        }
      });
    }).onSucceeded(function (message) {
      logger.info('Thread | useSendVoiceMessageCallback: Sending voice message succeeded.', message);
      pubSub.publish(PUBSUB_TOPICS.SEND_FILE_MESSAGE, {
        channel: currentChannel,
        message: message
      });
    });
  }, [currentChannel, onBeforeSendVoiceMessage]);
  return sendMessage;
};
var ThreadContext = /*#__PURE__*/React__default.createContext(null);
var ThreadProvider = function ThreadProvider(props) {
  var _allThreadMessages$, _allThreadMessages;
  var children = props.children,
    channelUrl = props.channelUrl,
    onHeaderActionClick = props.onHeaderActionClick,
    onMoveToParentMessage = props.onMoveToParentMessage,
    onBeforeSendVoiceMessage = props.onBeforeSendVoiceMessage,
    disableUserProfile = props.disableUserProfile,
    renderUserProfile = props.renderUserProfile;
  var propsMessage = props === null || props === void 0 ? void 0 : props.message;
  var propsParentMessage = getParentMessageFrom(propsMessage);
  // Context from SendbirdProvider
  var globalStore = useSendbirdStateContext();
  var stores = globalStore.stores,
    config = globalStore.config; // // stores
  var sdkStore = stores.sdkStore,
    userStore = stores.userStore;
  var sdk = sdkStore.sdk;
  var user = userStore.user;
  var sdkInit = sdkStore === null || sdkStore === void 0 ? void 0 : sdkStore.initialized;
  // // config
  var logger = config.logger,
    pubSub = config.pubSub,
    replyType = config.replyType,
    isMentionEnabled = config.isMentionEnabled,
    isReactionEnabled = config.isReactionEnabled,
    onUserProfileMessage = config.onUserProfileMessage; // dux of Thread
  var _useReducer = useReducer(reducer, initialState),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    threadStore = _useReducer2[0],
    threadDispatcher = _useReducer2[1];
  var currentChannel = threadStore.currentChannel,
    allThreadMessages = threadStore.allThreadMessages,
    parentMessage = threadStore.parentMessage,
    channelState = threadStore.channelState,
    threadListState = threadStore.threadListState,
    parentMessageState = threadStore.parentMessageState,
    hasMorePrev = threadStore.hasMorePrev,
    hasMoreNext = threadStore.hasMoreNext,
    emojiContainer = threadStore.emojiContainer,
    isMuted = threadStore.isMuted,
    isChannelFrozen = threadStore.isChannelFrozen,
    currentUserId = threadStore.currentUserId; // Initialization
  useEffect(function () {
    threadDispatcher({
      type: ThreadContextActionTypes.INIT_USER_ID,
      payload: user === null || user === void 0 ? void 0 : user.userId
    });
  }, [user]);
  useGetChannel({
    channelUrl: channelUrl,
    sdkInit: sdkInit,
    message: propsMessage
  }, {
    sdk: sdk,
    logger: logger,
    threadDispatcher: threadDispatcher
  });
  useGetParentMessage({
    channelUrl: channelUrl,
    sdkInit: sdkInit,
    parentMessage: propsParentMessage
  }, {
    sdk: sdk,
    logger: logger,
    threadDispatcher: threadDispatcher
  });
  useGetThreadList({
    sdkInit: sdkInit,
    parentMessage: parentMessage,
    isReactionEnabled: isReactionEnabled,
    anchorMessage: (propsMessage === null || propsMessage === void 0 ? void 0 : propsMessage.messageId) !== (propsParentMessage === null || propsParentMessage === void 0 ? void 0 : propsParentMessage.messageId) ? propsMessage : null
    // anchorMessage should be null when parentMessage doesn't exist
  }, {
    logger: logger,
    threadDispatcher: threadDispatcher
  });
  useGetAllEmoji({
    sdk: sdk
  }, {
    logger: logger,
    threadDispatcher: threadDispatcher
  });
  // Handle channel events
  useHandleChannelEvents({
    sdk: sdk,
    currentChannel: currentChannel
  }, {
    logger: logger,
    threadDispatcher: threadDispatcher
  });
  useHandlePubsubEvents({
    sdkInit: sdkInit,
    currentChannel: currentChannel,
    parentMessage: parentMessage
  }, {
    logger: logger,
    pubSub: pubSub,
    threadDispatcher: threadDispatcher
  });

  // callbacks
  var fetchPrevThreads = useGetPrevThreadsCallback({
    hasMorePrev: hasMorePrev,
    parentMessage: parentMessage,
    threadListState: threadListState,
    isReactionEnabled: isReactionEnabled,
    oldestMessageTimeStamp: ((_allThreadMessages$ = allThreadMessages[0]) === null || _allThreadMessages$ === void 0 ? void 0 : _allThreadMessages$.createdAt) || 0
  }, {
    logger: logger,
    threadDispatcher: threadDispatcher
  });
  var fetchNextThreads = useGetNextThreadsCallback({
    hasMoreNext: hasMoreNext,
    parentMessage: parentMessage,
    threadListState: threadListState,
    isReactionEnabled: isReactionEnabled,
    latestMessageTimeStamp: ((_allThreadMessages = allThreadMessages[allThreadMessages.length - 1]) === null || _allThreadMessages === void 0 ? void 0 : _allThreadMessages.createdAt) || 0
  }, {
    logger: logger,
    threadDispatcher: threadDispatcher
  });
  var toggleReaction = useToggleReactionCallback({
    currentChannel: currentChannel
  }, {
    logger: logger
  });
  var sendMessage = useSendUserMessageCallback({
    isMentionEnabled: isMentionEnabled,
    currentChannel: currentChannel
  }, {
    logger: logger,
    pubSub: pubSub,
    threadDispatcher: threadDispatcher
  });
  var sendFileMessage = useSendFileMessageCallback({
    currentChannel: currentChannel
  }, {
    logger: logger,
    pubSub: pubSub,
    threadDispatcher: threadDispatcher
  });
  var sendVoiceMessage = useSendVoiceMessageCallback({
    currentChannel: currentChannel,
    onBeforeSendVoiceMessage: onBeforeSendVoiceMessage
  }, {
    logger: logger,
    pubSub: pubSub,
    threadDispatcher: threadDispatcher
  });
  var resendMessage = useResendMessageCallback({
    currentChannel: currentChannel
  }, {
    logger: logger,
    pubSub: pubSub,
    threadDispatcher: threadDispatcher
  });
  var updateMessage = useUpdateMessageCallback({
    currentChannel: currentChannel,
    isMentionEnabled: isMentionEnabled
  }, {
    logger: logger,
    pubSub: pubSub,
    threadDispatcher: threadDispatcher
  });
  var deleteMessage = useDeleteMessageCallback({
    currentChannel: currentChannel,
    threadDispatcher: threadDispatcher
  }, {
    logger: logger
  });

  // memo
  var nicknamesMap = useMemo(function () {
    return replyType && currentChannel ? getNicknamesMapFromMembers(currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members) : new Map();
  }, [currentChannel === null || currentChannel === void 0 ? void 0 : currentChannel.members]);
  return /*#__PURE__*/React__default.createElement(ThreadContext.Provider, {
    value: {
      // ThreadProviderProps
      channelUrl: channelUrl,
      message: propsMessage,
      onHeaderActionClick: onHeaderActionClick,
      onMoveToParentMessage: onMoveToParentMessage,
      // ThreadContextInitialState
      currentChannel: currentChannel,
      allThreadMessages: allThreadMessages,
      parentMessage: parentMessage,
      channelState: channelState,
      threadListState: threadListState,
      parentMessageState: parentMessageState,
      hasMorePrev: hasMorePrev,
      hasMoreNext: hasMoreNext,
      emojiContainer: emojiContainer,
      // hooks
      fetchPrevThreads: fetchPrevThreads,
      fetchNextThreads: fetchNextThreads,
      toggleReaction: toggleReaction,
      sendMessage: sendMessage,
      sendFileMessage: sendFileMessage,
      sendVoiceMessage: sendVoiceMessage,
      resendMessage: resendMessage,
      updateMessage: updateMessage,
      deleteMessage: deleteMessage,
      // context
      nicknamesMap: nicknamesMap,
      isMuted: isMuted,
      isChannelFrozen: isChannelFrozen,
      currentUserId: currentUserId
    }
  }, /*#__PURE__*/React__default.createElement(UserProfileProvider, {
    disableUserProfile: disableUserProfile !== null && disableUserProfile !== void 0 ? disableUserProfile : config.disableUserProfile,
    renderUserProfile: renderUserProfile,
    onUserProfileMessage: onUserProfileMessage
  }, children));
};
var useThreadContext = function useThreadContext() {
  return React__default.useContext(ThreadContext);
};
export { ThreadProvider as T, compareMessagesForGrouping as c, isAboutSame as i, useThreadContext as u };